import React from "react";

export default function SvgComponent() {
  return (
    <svg viewBox="0 0 145 145" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0h145v145H0z" fill="#30ace2" />
      <path
        d="M80.123 29.486s-6.885-7.69-17.931-2.771c-7.717 3.438-9.388 5.689-15.975 7.19-6.954 1.585-11.612 8.499-8.915 16.635 2.243 6.766 4.136 15.674 2.663 19.479-1.941 5.016-.04 8.887 6.606 13.604 6.647 4.717 17.24 9.335 17.24 9.335l19.281-1.348s23.688-4.499 21.983-16.622c-1.231-8.745-3.232-9.549 1.196-14.899 2.838-3.43 2.791-14.756-3.855-18.615-6.647-3.858-5.928-8.484-9.573-11.7-3.645-3.216-12.72-.288-12.72-.288z"
        fill="#3c2a20"
      />
      <path
        d="M109.374 115.395c-4.963-9.396-36.874-15.292-36.874-15.292s-31.911 5.896-36.874 15.292C31.957 128.434 28.889 145 28.889 145h87.222s-2.072-17.764-6.737-29.605z"
        fill="#f1c9a5"
      />
      <path
        d="M72.5 100.103s31.911 5.896 36.874 15.292c4.665 11.842 6.737 29.605 6.737 29.605H72.5v-44.897z"
        fill="#e4b692"
      />
      <path d="M63.813 81.001h17.375v29.077H63.813z" fill="#f1c9a5" />
      <path d="M72.5 81.001h8.688v29.077H72.5z" fill="#e4b692" />
      <path
        d="M63.813 94.475c1.563 4.485 7.869 7.057 12.5 7.057 1.676 0 3.306-.28 4.875-.795V81.001H63.813v13.474z"
        fill="#ddac8c"
        opacity=".1"
      />
      <path
        d="M94.838 62.653c0-18.162-10.001-28.489-22.338-28.489-12.336 0-22.338 10.327-22.338 28.489S60.164 95.539 72.5 95.539c12.337 0 22.338-14.724 22.338-32.886z"
        fill="#f1c9a5"
      />
      <path
        d="M94.838 62.653c0-18.162-10.001-28.489-22.338-28.489v61.375c12.337 0 22.338-14.724 22.338-32.886z"
        fill="#e4b692"
      />
      <path
        d="M109.374 115.395c-1.665-3.152-6.368-5.908-11.877-8.183-2.771 11.233-12.909 19.565-24.997 19.565s-22.227-8.332-24.997-19.565c-5.508 2.274-10.212 5.03-11.877 8.183C31.957 128.434 28.889 145 28.889 145h87.222s-2.072-17.764-6.737-29.605z"
        fill="#bf0020"
      />
      <path
        d="M76.234 34.459c-.398-.399-19.659-5.292-18.626 5.553.798 8.377-5.167 8.045-9.041 14.3-3.875 6.256-4.24 10.453-.47 15.709.336-3.947.47-9.387 8.846-15.709 8.377-6.321 8.111-9.38 7.047-13.502-1.063-4.122 12.244-6.351 12.244-6.351z"
        fill="#3c2a20"
      />
      <path
        d="M55.481 80.3c-9.767-5.88-8.108-14.849-7.751-19.324.421-5.251 5.768-6.877 12.069-10.658 6.301-3.779 2.082-5.666 4.602-11.967 2.521-6.301 16.541-4.056 16.541-4.056s-8.228.061-10.747 6.361c-2.521 6.302 1.051 8.191-5.251 11.972-6.301 3.78-9.534 3.77-11.026 8.822-1.551 5.255-5.756 9.187 1.563 18.85z"
        fill="#564036"
      />
      <path
        d="M46.057 72.885c-9.767-5.879-6.239-11.906-5.882-16.382.421-5.251 3.863-6.283 10.165-10.063 6.301-3.78 3.592-4.429 6.113-10.729C58.974 29.41 72.94 33.61 72.94 33.61s-8.821-1.891-11.342 4.41c-2.521 6.303.381 7.252-5.251 11.972-3.992 3.347-11.319 3.563-11.026 8.822.368 6.586-7.036 8.19.736 14.071z"
        fill="#564036"
      />
      <path
        d="M69.944 33.927c.399-.398 19.66-5.291 18.627 5.554-.798 8.377 5.166 8.044 9.041 14.3 3.875 6.255 4.24 10.453.469 15.708-.336-3.947-.469-9.387-8.846-15.708-8.376-6.322-8.11-9.38-7.047-13.502 1.065-4.123-12.244-6.352-12.244-6.352z"
        fill="#3c2a20"
      />
      <path
        d="M91.525 78.713c9.767-6.405 6.239-12.972 5.882-17.849-.421-5.721-3.51-5.759-9.812-9.878-6.301-4.118-2.667-5.894-5.188-12.758-2.521-6.864-17.172-4.431-17.172-4.431s8.227.066 10.747 6.931c2.521 6.866-1.051 8.926 5.251 13.043 6.301 4.119 10.606 3.892 11.026 9.612.36 4.877 7.038 8.922-.734 15.33z"
        fill="#564036"
      />
      <path
        d="M100.424 76.874c9.876-6.534 6.309-13.23 5.947-18.204-.425-5.835-3.906-6.982-10.279-11.183-6.371-4.201-3.631-4.922-6.181-11.923-2.549-7.002-16.673-2.334-16.673-2.334s8.921-2.101 11.469 4.9c2.55 7.004-.385 8.058 5.31 13.304 4.037 3.718 11.447 3.959 11.15 9.803-.371 7.321 7.115 9.101-.743 15.637z"
        fill="#564036"
      />
      <path
        d="M97.497 107.212s-9.245 3.77-7.813 12.982c-4.951-.36-15.588.762-17.184 6.583-3.723-5.17-12.434-7.961-17.651-7.009-.076-5.253-3.489-10.641-7.346-12.557-4.786 9.387-2.046 18.96-2.046 18.96s12.151 10.238 12.816 10.238c.665 0 25.661 4.388 25.661 4.388s16.689-5.452 16.788-5.983c.099-.532-3.225-27.602-3.225-27.602z"
        fill="#bf0020"
      />
      <path
        d="M87.993 45.597s1.792 8.187 10.036 16.088c3.521 3.377.798 18.083-6.781 25.396 6.515-5.318 16.035-16.403 11.833-25.396-4.201-8.993-13.19-12.075-15.088-16.088zM60.048 45.016s-2.265 10.496-10.509 18.397c-3.521 3.377-4.405 13.529 3.174 20.842-6.516-5.318-12.428-11.849-8.227-20.842 4.202-8.992 13.664-14.384 15.562-18.397z"
        fill="#564036"
      />
      <g fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="1.943">
        <path d="M59.228 103.094v.034" />
        <path
          d="M59.48 105.718c1.223 6.252 6.733 10.969 13.344 10.969 7.057 0 12.861-5.378 13.531-12.26"
          strokeDasharray=".0651,2.6035"
        />
        <path d="M86.42 103.128v-.034" />
      </g>
    </svg>
  );
}
